import { AccountSwitcherOptionGroupDesktop } from "./AccountSwitcherOptionGroup";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";

interface AccountSwitcherMenuWorkplaceDesktopProps {
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
}

export function AccountSwitcherMenuWorkplaceDesktop(
  props: AccountSwitcherMenuWorkplaceDesktopProps
) {
  const { workplaceDetails, onUserClicked } = props;

  return (
    <AccountSwitcherOptionGroupDesktop
      userDetails={workplaceDetails}
      onUserClicked={onUserClicked}
    />
  );
}
